export const VModel = {
  props: {
    value: {
      default: undefined,
      description: "set v-model value from parent component"
    },
    nullable: {
      default: true,
      description: "if the v-model value is allowed to be null"
    }
  },
  watch: {
    'model': function (newValue, oldValue) {
      if (newValue || this.nullable) {
        this.emitter(newValue);
      } else if (oldValue) {
        /*
         * Prevent this.model from being set to null
         * if oldValue is set and v-model is not nullable.
         * Note that this will trigger another watch/emit
         * with oldValue being emitted.
         */
        this.model = oldValue
      }
    },
  },
  data() {
    return {
      model: undefined,
    }
  },
  mounted() {
    this.loadModel()
  },
  methods: {
    emitter(val) {
      this.$emit("input", val)
    },
    loadModel() {
      if (this.value !== undefined) {
        this.model = this.value;
      }
    }
  }
}
